<div class="file-details" *ngIf="fileDetails">
  <div class="container-fluid file-info pt-4 pb-1">
    <div class="py-4">
      <app-breadcrumb-navigation
        [link]="LINK_FILES_MANAGER"
        [dataTestId]="'files-link'"
        [pageToNavigateTitle]="'PROFILE_NAVIGATION_FILES'"
        [pageTitle]="fileDetails.entity.name"
      ></app-breadcrumb-navigation>
    </div>
    <div class="pb-4">
      <ng-container *ngIf="isFileOwner; else unshareBtn">
        <button type="button" data-test-id="share-file-btn" (click)="shareFile()" class="btn btn-primary">
          {{ 'BTN_SHARE' | translate }}
        </button>
      </ng-container>
      <ng-template #unshareBtn>
        <button type="button" data-test-id="unshare-file-btn" (click)="unshareFile()" class="btn btn-primary">
          {{ 'BTN_UNSHARE' | translate }}
        </button>
      </ng-template>
    </div>
    <div class="row file-row">
      <div class="col-md-8">
        <iframe
          data-test-id="details-iframe"
          *ngIf="fileTrustedUrl"
          [src]="fileTrustedUrl"
          frameborder="0"
          [height]="height"
        >
        </iframe>
      </div>
      <div class="col-md-4 tabs-holder">
        <ul ngbNav #nav="ngbNav" class="nav-tabs">
          <li NgbNavItem>
            <a ngbNavLink>{{ 'ACTIVITY_TAB' | translate }} </a>

            <ng-template ngbNavContent>
              <app-file-history [fileHistory]="fileHistory"></app-file-history>
            </ng-template>
          </li>

          <li NgbNavItem>
            <a ngbNavLink>{{ 'ABOUT_TAB' | translate }} </a>

            <ng-template ngbNavContent>
              <dl class="py-4">
                <dt class="h5 m-0 text-dark">
                  {{ 'FILE_UPLOADED_BY' | translate }}
                </dt>
                <dd class="text-muted" data-test-id="file-upload-by">
                  {{ fileDetails.entity.creator_account_id }}
                </dd>
                <dt class="h5 m-0 text-dark">
                  {{ 'FILE_DATE_UPLOADED' | translate }}
                </dt>
                <dd class="text-muted" data-test-id="file-upload-date">
                  {{ fileDetails.entity.created | date: DATE_TIME_FORMAT_SHORT }}
                </dd>
                <dt class="h5 m-0 text-dark">
                  {{ 'FILE_LAST_MODIFIED' | translate }}
                </dt>
                <dd class="text-muted" data-test-id="file-modified-date">
                  {{ fileDetails.entity.modified | date: DATE_TIME_FORMAT_SHORT }}
                </dd>
                <dt class="h5 m-0 text-dark">
                  {{ 'FILE_EXTENSION' | translate }}
                </dt>
                <dd class="text-muted" data-test-id="file-conetnt-type">
                  {{ fileDetails.entity['content_type'] }}
                </dd>
                <dt class="h5 m-0 text-dark">
                  {{ 'FILE_SIZE' | translate }}
                </dt>
                <dd class="text-muted" data-test-id="file-size">
                  {{ fileDetails.entity['size'] }}
                </dd>
              </dl>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
      </div>
    </div>
  </div>
</div>
